import { render, staticRenderFns } from "./CashRegisterModalButton.vue?vue&type=template&id=522cd1ad"
import script from "./CashRegisterModalButton.vue?vue&type=script&lang=js"
export * from "./CashRegisterModalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports